import { FC } from 'react';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { CarFeature } from 'shared/types/models';

const MAIN_TYPES = ['TECHNOLOGY', 'SAFETY', 'PERFORMANCE'];
const OTHER_TYPE = 'OTHER';

const CategoryType: FC<{
  type: string;
  features: { id?: number; name: string; type: string }[];
}> = ({ type, features }) => {
  if (features.length === 0) {
    return null;
  }

  return (
    <div>
      <Typography variant='subtitle2' display='block'>
        {type}:
      </Typography>
      {features.map((feature) => {
        return (
          <Chip
            key={feature.id}
            label={feature.name}
            sx={{
              my: 0.5,
              mr: 0.5,
            }}
            size='small'
          />
        );
      })}
    </div>
  );
};

export const CarFeatures: FC<{ features: CarFeature[] }> = ({ features }) => {
  if (!features?.length) {
    return (
      <Typography variant='body1' color='textSecondary'>
        Information about installed features is not available for this vehicle.
      </Typography>
    );
  }

  return (
    <Box display={'flex'} flexWrap={'wrap'} flexDirection={'column'} gap={2}>
      {MAIN_TYPES.map((type, index) => {
        return (
          <CategoryType
            key={index}
            type={type}
            features={features.filter((feature) => feature.type === type)}
          />
        );
      })}
      <CategoryType
        type={OTHER_TYPE}
        features={features.filter(
          (feature) => !MAIN_TYPES.includes(feature.type),
        )}
      />
    </Box>
  );
};
